"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const react_core_2 = require("@patternfly/react-core");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const common_1 = require("../../../../common");
const ModalDialogsContext_1 = require("../../hosts/ModalDialogsContext");
const Day2ClusterDetails_1 = tslib_1.__importDefault(require("./Day2ClusterDetails"));
const Day2DownloadISO_1 = tslib_1.__importDefault(require("./Day2DownloadISO"));
const Day2GenerateISO_1 = tslib_1.__importDefault(require("./Day2GenerateISO"));
const Day2StaticIP_1 = tslib_1.__importDefault(require("./Day2StaticIP"));
const Day2WizardNav_1 = tslib_1.__importDefault(require("./Day2WizardNav"));
const Day2WizardContext_1 = require("./Day2WizardContext");
const Day2WizardStep = () => {
    const wizardContext = (0, Day2WizardContext_1.useDay2WizardContext)();
    const step = wizardContext.currentStepId;
    switch (step) {
        case 'cluster-details':
            return react_1.default.createElement(Day2ClusterDetails_1.default, null);
        case 'generate-iso':
            return react_1.default.createElement(Day2GenerateISO_1.default, null);
        case 'download-iso':
            return react_1.default.createElement(Day2DownloadISO_1.default, null);
        case 'static-ip-network-wide-configurations':
        case 'static-ip-host-configurations':
        case 'static-ip-yaml-view':
            return react_1.default.createElement(Day2StaticIP_1.default, null);
        default:
            return react_1.default.createElement(common_1.ClusterWizardStep, { navigation: react_1.default.createElement(Day2WizardNav_1.default, null) },
                "Step ",
                step);
    }
};
const Day2Wizard = () => {
    const { day2DiscoveryImageDialog } = (0, ModalDialogsContext_1.useModalDialogsContext)();
    const { isOpen, close } = day2DiscoveryImageDialog;
    return (react_1.default.createElement(react_core_1.Modal, { "aria-label": 'Day 2 Wizard', isOpen: isOpen, variant: react_core_1.ModalVariant.large, showClose: false, hasNoBodyWrapper: true, id: "generate-discovery-iso-modal" },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('pf-v5-c-wizard', 'cluster-wizard') },
            react_1.default.createElement(react_core_2.WizardHeader, { title: 'Add hosts', description: 'Choose the settings for adding a new host', onClose: close }),
            react_1.default.createElement(Day2WizardStep, null))));
};
exports.default = Day2Wizard;
//# sourceMappingURL=Day2Wizard.js.map